export interface Position {
    latitud: number,
    longitud: number
}

export function createEmptyPosition() : Position {
    return {
        latitud: null,
        longitud: null
    }
}